module.exports = __webpack_public_path__ + "resources/icon_28_hot.d502481448235eea.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_hot.png
// module id = 476
// module chunks = 0 1 2 3 4